import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { TechnicalReportSectionDto } from "@/core/features/technical-report-sections/technical-report-section.dto";

export class TechnicalReportSectionsResource extends ResourceBaseService<TechnicalReportSectionDto, null, null> {
  protected EntityDto = TechnicalReportSectionDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/technical-report-sections");
  }
}
